/**
 * Usage field formatter
 */

import {useUsage} from '@hconnect/tuc-processes/fields'
import {useChangeableField} from '@hconnect/tuc-processes/orderManagement/orderChange'

import type {FieldFormatter} from './types'
import {createValueArray} from './utils'

export const useUsageFormatter = (): FieldFormatter => {
  const {usage, defaultUsage} = useUsage()
  const usageState = useChangeableField('concreteUsage')

  return (context) => {
    const {t} = context
    const requiresApproval = usageState.state === 'requireDispatchConfirmation'
    const hasChanges = usageState.isDirty
    const oldValue = defaultUsage || null
    const newValue = usage || null

    const values = createValueArray(
      oldValue,
      newValue,
      hasChanges,
      t('orderIntake.rmc.orderManagement.notSpecified', 'Not specified')
    )

    return {values, requiresApproval, hasChanges}
  }
}
